import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import ClientSidebar from "components/Sidebar/ClientSidebar.js";
import PrivateRoute from "components/PrivateRoute";
import styled from "styled-components";
import { useWindowSize } from "hooks/useWindowSize";

const SidebarWrapper = styled.div`
  width: 200px;
  top: 0 !important;
  height: 100vh;
  max-height: 100vh;

  @media (max-width: 768px) {
    position: fixed;
    z-index: 1000;
  }
`;

export const Layout = () => {
  const [sidebarWidth, setSidebarWidth] = useState(200);
  const { width } = useWindowSize();
  return (
    <PrivateRoute>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <SidebarWrapper style={{ width: `${sidebarWidth}px` }}>
          <ClientSidebar
            onClosed={(closed) => {
              console.log("!!! CLOSED", closed);
              if (closed) {
                setSidebarWidth(10);
              } else {
                setSidebarWidth(200);
              }
            }}
          />
        </SidebarWrapper>
        <div
          style={{
            marginTop: "40px",
            marginLeft: "20px",
            marginRight: "20px",
            width: `calc(100% - ${sidebarWidth + 40}px)`,
            position: "relative",
            zIndex: 1,
            /*height: "2000px",*/
          }}
        >
          <Outlet />
        </div>
      </div>
    </PrivateRoute>
  );
};

export default Layout;
